<!-- src/app/components/sidemenu/sidemenu.component.html -->
<tds-side-menu aria-label="Side menu" persistent collapsed="true">

  <tds-side-menu-close-button slot="close-button"></tds-side-menu-close-button>

  <!-- ADMIN: só aparece se tiver AdmUPS -->
  <tds-side-menu-item *ngIf="isAdmUPS$ | async">
    <a [routerLink]="['/admin']"
       routerLinkActive="active"
       style="display:flex;align-items:center;width:100%;text-decoration:none;">
      <tds-icon name="profile" size="24"></tds-icon>
      <span style="margin-left: 12px;">Administrador</span>
    </a>
  </tds-side-menu-item>

  <!-- TABLE MANAGEMENT: só aparece se tiver AdmUPS -->
  <tds-side-menu-item *ngIf="isAdmUPS$ | async">
    <a [routerLink]="['/table-management']"
       routerLinkActive="active"
       style="display:flex;align-items:center;width:100%;text-decoration:none;">
      <tds-icon name="settings" size="24"></tds-icon>
      <span style="margin-left: 12px;">Gerenc. Tabelas</span>
    </a>
  </tds-side-menu-item>

  <tds-side-menu-item>
    <a [routerLink]="['/issues']"
       routerLinkActive="active"
       style="display:flex;align-items:center;width:100%;text-decoration:none;">
      <tds-icon name="star" size="24"></tds-icon>
      <span style="margin-left: 12px;">Lista de Issues</span>
    </a>
  </tds-side-menu-item>

  <tds-side-menu-item>
    <a [routerLink]="['/sprint-planning']"
       routerLinkActive="active"
       style="display:flex;align-items:center;width:100%;text-decoration:none;">
      <tds-icon name="calendar" size="24"></tds-icon>
      <span style="margin-left: 12px;">Sprint Planning</span>
    </a>
  </tds-side-menu-item>

  <tds-side-menu-item>
    <a [routerLink]="['/dashboards']"
       routerLinkActive="active"
       style="display:flex;align-items:center;width:100%;text-decoration:none;">
      <tds-icon name="dashboard" size="24"></tds-icon>
      <span style="margin-left: 12px;">Dashboards</span>
    </a>
  </tds-side-menu-item>

  <tds-side-menu-collapse-button slot="sticky-end">Collapse</tds-side-menu-collapse-button>
</tds-side-menu>
